import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionsService {

  private accessTokenUser = '';
  private nameUser = '';

  private adminActivationToken = '';

  constructor() { }

  public registerSessionAdmin(token:string) {
    this.adminActivationToken = token;
  }

  public destroyAdmin() {
    this.adminActivationToken = null
  }

  public registerSessionUser(token: string, name: string) {
    this.accessTokenUser = token;
    this.nameUser = name;
  }

  public getAccessTokenAdmin(): string {
    return this.adminActivationToken;
  }

  public getAccessTokenUser(): string {
    return this.accessTokenUser;
  }

  public getNameUser(): string {
    return this.nameUser;
  }

  public destroyUser(): void {
    this.accessTokenUser = null;
    this.nameUser = null;
  }
}
